import { createApp } from './vue';

import accordion from './vue/apps/accordion';

const accordionMountingContainer = document.querySelectorAll('.js-accordion');

if (accordionMountingContainer) {
    const accordions = [];

    accordionMountingContainer.forEach((el) => {
        const app = createApp(accordion).mount(el);
        accordions.push(app);
    });
}
